export function checkPreOrderBlocked(
  brand:
    | { preOrderBlock: boolean; preOrderBlockStartDate: string | null; preOrderBlockEndDate: string | null }
    | null
    | undefined,
  now: number = Date.now(),
): boolean {
  if (!brand?.preOrderBlock) {
    return false
  }

  const start = brand.preOrderBlockStartDate ? new Date(brand.preOrderBlockStartDate).getTime() : null
  const end = brand.preOrderBlockEndDate ? new Date(brand.preOrderBlockEndDate).getTime() : null
  if (!start || !end) {
    return false
  }

  return now >= start && now <= end
}

export function usePreOrderBlock() {
  const brandsStore = useBrandsStore()
  const now = ref(Date.now())

  if (getCurrentScope()) {
    const interval = setInterval(() => {
      now.value = Date.now()
    }, 60_000)
    onScopeDispose(() => clearInterval(interval))
  }

  const isPreOrderBlocked = computed(() => checkPreOrderBlocked(brandsStore.selectedBrand, now.value))

  const preOrderBlockEndDate = computed(() => brandsStore.selectedBrand?.preOrderBlockEndDate ?? null)
  const preOrderSeasonTitle = computed(() => brandsStore.selectedBrand?.preOrderSeasonTitle ?? null)

  return {
    isPreOrderBlocked,
    preOrderBlockEndDate,
    preOrderSeasonTitle,
  }
}
